module.exports = __webpack_public_path__ + "img/icon_informe_comentarios.9e629c10.svg";